export default "__VITE_ASSET__c27dea9c__"